require('../../modules/es6.array.is-array');
module.exports = require('../../modules/_core').Array.isArray;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/array/is-array.js
// module id = 4548
// module chunks = 25